export var initialDataContext = {
    state: null,
    setState: null,
};
export var initialRootState = {
    navigationExpanded: false,
    yOffsetBurdy: 0,
};
